import {
  SlideNextItem,
  SlidePreviousItem,
  SliderContainer,
  useIsMobile,
} from '@ferreri/prever-component-lib';
import { useSpringCarousel } from 'react-spring-carousel';

import { PlanVersion } from '../admin/plan-versions/plan-version.type';
import { Benefit } from '../plan-benefit/plan-benefit.types';
import CardPlanVersion from './CardPlanVersion';

type PlanVersionsListCarouselProps = {
  planVersions?: PlanVersion[];
  benefits?: Benefit[];
};

export const PlanVersionsListCarousel = (
  props: PlanVersionsListCarouselProps,
) => {
  const isMobile = useIsMobile();
  const showSliderButton = props.planVersions && props.planVersions.length > 4;
  const amount = props.planVersions?.length;

  const { carouselFragment, slideToNextItem, slideToPrevItem } =
    useSpringCarousel({
      gutter: 16,
      startEndGutter: 16,
      itemsPerSlide: isMobile ? 1 : amount >= 4 ? 4 : amount,
      items: (props.planVersions || []).map((planVersion) => ({
        id: planVersion.id,
        renderItem: (
          <CardPlanVersion
            key={planVersion.id}
            planVersionId={planVersion.id}
            benefits={props.benefits}
          />
        ),
      })),
    });

  return (
    <SliderContainer>
      {showSliderButton && <SlidePreviousItem onClick={slideToPrevItem} />}
      {carouselFragment}
      {showSliderButton && <SlideNextItem onClick={slideToNextItem} />}
    </SliderContainer>
  );
};
